// Browser ES6 Polyfill
require('babel/polyfill');




/** WEBPACK FOOTER **
 ** ./app/src/vendor.js
 **/